import http from "@/apis/http";
import url from "@/config/url";

const member = url.member;

export default {
  getAddInfo: (params) => http.post(member.info, { ...params, action: "add" }),
  getEditInfo: (params) =>
    http.post(member.info, { ...params, action: "edit" }),
  board: {
    getData: (params) => http.post(member.board.search, params),
    updateStatus: (params) => http.post(member.board.action, params),
    getColumns: (params) => http.post(member.board.columns, params),
    updateHandicap: (params) => http.post(member.board.update_handicap, params),
    updateLimitBet: (params) => http.post(member.board.update_limit_bet, params),
    updateMemberBatch: (params) => http.post(member.board.update_member_batch, params),
  },
  profile: {
    getData: (params) => http.post(member.info, { ...params, action: "info" }),
    getThirdPartyWallet: (params) => http.post(member.info, { ...params, action: "thirdPartyWallet" }),
  },
  sub: {
    getData: (params) => http.post(member.sub.search, params),
    getColumns: (params) => http.post(member.sub.columns, params),
    update: (params) =>
      http.post(member.sub.action, { ...params, action: "update" }),
    add: (params) => http.post(member.sub.action, { ...params, action: "add" }),
    del: (params) => http.post(member.sub.action, { ...params, action: "del" }),
  },
  admin: {
    getData: (params) => http.post(member.admin.search, params),
    getColumns: (params) => http.post(member.admin.columns, params),
    update: (params) =>
      http.post(member.admin.action, { ...params, action: "update" }),
    add: (params) => http.post(member.admin.action, { ...params, action: "add" }),
    getPermissions: (params) => http.post(member.admin.permissions, params),
  },
  action: {
    update: (params) =>
      http.post(member.action, { ...params, action: "update" }),
    add: (params) => http.post(member.action, { ...params, action: "create" }),
    delete: (params) =>
      http.post(member.action, { ...params, action: "delete" }),
    registerMobile: (params) =>
      http.post(member.action, { ...params, action: "registerMobile" }),
    unlock: (params) =>
      http.post(member.action, { ...params, action: "unlock" }),
    removePunish: (params) =>
      http.post(member.action, { ...params, action: "removePunish" }),
  },
  trial: {
    getData: (params) => http.post(member.trial.search, params),
    getColumns: (params) => http.post(member.trial.columns, params),
    getApplyData: (params) => http.post(member.trial.apply_info, params),
    apply: (params) => http.post(member.trial.apply, params),
  },
  distributed: {
    getColumns: (params) => http.post(member.distributed.columns, params),
    agent: (params) => http.post(member.distributed.agent, params),
    level: (params) => http.post(member.distributed.level, params),
    member: (params) => http.post(member.distributed.member, params),
  },
  updateMaterial: {
    dangerLevel: (params) => http.post(member.updateMaterial, {...params, material: 'danger_level'}),
  }
};
